export const getDesignLibraryElementNode = (id) => document.getElementById(id);
//# sourceMappingURL=getDesignLibraryElementNode.js.map